/* BYON · Colecciones, orden y búsqueda (rediseño UX sep-2026, agente Colecciones; R1)
 * Se apoya en el facets.js de Dawn (FacetFiltersForm.renderPage) sin reescribirlo. Los filtros (panel bajo 990 px y
 * barra lateral) viven en assets/byon-facets.js (C1-COL-13); este archivo cubre:
 * - Barra fija bajo 990 px: "Filtrar (n)" abre el panel (ByonFacets.open); "Ordenar" abre una hoja inferior; chips de
 *   filtro rápido y filtros activos se aplican sin recargar (Section Rendering API).
 * - Chips de subcategoría del encabezado: bajo 990 px van en la barra fija; desde 990 px se quedan en el encabezado y
 *   se ven en la barra superior solo desde el ancho en que caben todos (bp del encabezado, ≥ 1300 px, por CSS; aquí
 *   se copian y se comprueba que caben; R2 · C1-COL-16, opción d con respaldo); sin JS se ven en el encabezado.
 * - "Cargar más": agrega la página siguiente a la grilla y actualiza ?page=N (el link sigue siendo rastreable).
 * - Guía SEO: colapsada con "Leer más" (el texto completo siempre está en el HTML).
 * - Offset de elementos fijos: --byon-sticky-top = borde inferior del header fijo (si lo hay).
 * - Medición K1: filter_apply (chips, "Borrar todo"), sort_change (hoja y selector) y search_submit (página de búsqueda).
 * Contratos: agrega/quita "byon-overlay-open" en <body> mientras la hoja de orden está abierta.
 * R11 (D2 · SEO-3 A): la tarjeta "Guía rápida" (<li data-byon-tile>, interruptor aprende_elegir) ocupa una celda de la
 * grilla pero no es un producto: "Cargar más" y "Mostrando N de M" cuentan solo productos.
 */
(function () {
  if (window.ByonPLP) return;
  var ByonPLP = (window.ByonPLP = {});
  var doc = document;
  var root = doc.documentElement;

  function qs(selector, scope) {
    return (scope || doc).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.prototype.slice.call((scope || doc).querySelectorAll(selector));
  }

  function isPlainClick(event) {
    return !(event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey);
  }

  function track(name, data) {
    (window.byonTrack || function () {})(name, data);
  }

  function collectionKey() {
    var plp = qs('[data-byon-plp]');
    return (plp && plp.getAttribute('data-byon-collection')) || 'search';
  }

  function facetsOpen() {
    return !!(window.ByonFacets && window.ByonFacets.isOpen());
  }

  /* ---------- Offset bajo el header fijo ---------- */
  var stickyCandidates = [];
  var stickyValue = -1;
  var stickyCollectedAt = 0;

  function collectStickyCandidates() {
    stickyCollectedAt = Date.now();
    stickyCandidates = qsa(
      '.shopify-section-group-header-group, .section-header, sticky-header, [data-byon-sticky-header]'
    ).filter(function (el) {
      var position = window.getComputedStyle(el).position;
      return position === 'sticky' || position === 'fixed';
    });
  }

  function updateStickyTop() {
    if (Date.now() - stickyCollectedAt > 1500) collectStickyCandidates();
    var bottom = 0;
    var limit = window.innerHeight * 0.5;
    stickyCandidates.forEach(function (el) {
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return;
      var rect = el.getBoundingClientRect();
      if (rect.top <= 1 && rect.bottom > bottom && rect.bottom < limit) bottom = rect.bottom;
    });
    bottom = Math.max(0, Math.round(bottom));
    if (bottom !== stickyValue) {
      stickyValue = bottom;
      root.style.setProperty('--byon-sticky-top', bottom + 'px');
    }
  }

  var stickyTicking = false;
  function requestStickyUpdate() {
    if (stickyTicking) return;
    stickyTicking = true;
    window.requestAnimationFrame(function () {
      stickyTicking = false;
      updateStickyTop();
    });
  }

  // Clase FacetFiltersForm de facets.js, tomada del registro de custom elements: la propiedad global del mismo
  // nombre devuelve el <form id="FacetFiltersForm"> (acceso por id), no la clase.
  function getFacets() {
    var ctor = window.customElements && window.customElements.get('facet-filters-form');
    return ctor && typeof ctor.renderPage === 'function' ? ctor : null;
  }

  function canAjax() {
    return !!(getFacets() && qs('#product-grid'));
  }

  function currentSort() {
    var el = qs('#ProductGridContainer [data-byon-state]');
    return el ? el.getAttribute('data-sort') : null;
  }

  /* ---------- Conteo del encabezado ("7 de 46 productos" con filtros) ---------- */
  function syncHeaderCount() {
    var el = qs('[data-byon-colhead-count]');
    var stateEl = qs('#ProductGridContainer [data-byon-state]');
    var count = stateEl ? parseInt(stateEl.getAttribute('data-count'), 10) : NaN;
    // Búsqueda: el "(N)" del H1 sigue al conteo filtrado
    var searchCount = qs('.byon-search__count');
    if (searchCount && !isNaN(count) && searchCount.textContent !== '(' + count + ')') searchCount.textContent = '(' + count + ')';
    if (!el || isNaN(count)) return;
    var total = parseInt(el.getAttribute('data-total'), 10) || 0;
    var text = total === 1 ? '1 producto' : total + ' productos';
    if (count !== total) text = count + ' de ' + total + ' productos';
    if (el.textContent !== text) el.textContent = text;
  }

  function scrollToResults() {
    var container = qs('#ProductGridContainer');
    if (!container || facetsOpen()) return;
    var top = container.getBoundingClientRect().top + window.pageYOffset - stickyValue - 8;
    if (window.pageYOffset > top + 4) window.scrollTo(0, Math.max(0, top));
  }

  function renderParams(params) {
    closeSortSheet(true);
    scrollToResults();
    getFacets().renderPage(params);
  }

  function renderFromHref(href) {
    var url = new URL(href, window.location.href);
    if (url.pathname !== window.location.pathname || !canAjax()) {
      window.location.href = url.toString();
      return;
    }
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    renderParams(url.searchParams.toString());
  }

  function applySort(value) {
    if (!value || value === currentSort()) {
      closeSortSheet(false);
      return;
    }
    track('sort_change', { sort_by: value, collection: collectionKey() });
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    if (!canAjax()) {
      window.location.href = url.toString();
      return;
    }
    renderParams(url.searchParams.toString());
  }

  /* ---------- Hoja "Ordenar por" ---------- */
  var sheetOpener = null;

  function openSortSheet(trigger) {
    var id = trigger.getAttribute('aria-controls');
    var sheet = (id && doc.getElementById(id)) || qs('[data-byon-sort-sheet]');
    if (!sheet) return;
    sheetOpener = trigger;
    sheet.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    doc.body.classList.add('byon-overlay-open', 'overflow-hidden');
    var panel = qs('.byon-sheet__panel', sheet);
    var focusTarget = qs('[aria-pressed="true"]', sheet) || panel;
    if (typeof window.trapFocus === 'function') window.trapFocus(panel, focusTarget);
    else focusTarget.focus();
  }

  function closeSortSheet(silent) {
    var sheet = qsa('[data-byon-sort-sheet]').filter(function (el) {
      return !el.hidden;
    })[0];
    if (!sheet) return;
    sheet.hidden = true;
    if (!facetsOpen()) doc.body.classList.remove('overflow-hidden', 'byon-overlay-open');
    var opener = sheetOpener && doc.contains(sheetOpener) ? sheetOpener : qs('[data-byon-open-sort]');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus(silent ? null : opener);
    else if (!silent && opener) opener.focus();
    sheetOpener = null;
  }

  /* ---------- Chips de subcategoría en la barra superior (R2 · C1-COL-16, con respaldo) ----------
   * El encabezado calcula bp (data-byon-topbar-from): el ancho de pantalla desde el que caben todos los chips en una
   * línea de la barra (nunca menos de 1300 px). El cambio lo hace CSS (<style> en línea del encabezado): bajo bp los
   * chips se quedan en el encabezado; desde bp se ven aquí. Este JS copia la lista y mide: si no caben con "Ordenar
   * por" visible, la oculta a la vista (.is-tight); si ni así caben (estimación corta por otra fuente o zoom), los
   * devuelve al encabezado (.is-forced). Nunca queda un chip cortado. */
  function updateSubcatsOverflow() {
    var head = qs('.byon-colhead__chips');
    qsa('[data-byon-topbar-subcats]').forEach(function (list) {
      var topbar = list.closest('.byon-topbar');
      if (!topbar) return;
      topbar.classList.remove('is-tight');
      topbar.classList.remove('is-forced');
      if (head) head.classList.remove('is-forced');
      if (!list.getClientRects().length) return; // bajo bp la fila está en el encabezado
      if (list.scrollWidth > list.clientWidth + 1) topbar.classList.add('is-tight');
      if (list.scrollWidth > list.clientWidth + 1) {
        topbar.classList.remove('is-tight');
        topbar.classList.add('is-forced');
        if (head) head.classList.add('is-forced');
      }
    });
  }

  function syncTopbarChips() {
    var topbar = qs('#ProductGridContainer .byon-topbar');
    var source = qs('.byon-colhead__chips[data-byon-topbar-from]');
    if (!topbar || !source || qs('[data-byon-topbar-subcats]', topbar)) return;
    var list = source.cloneNode(true);
    list.className = 'byon-topbar__subcats';
    list.removeAttribute('data-byon-topbar-from');
    list.setAttribute('data-byon-topbar-subcats', '');
    var count = qs('.byon-topbar__count', topbar);
    topbar.insertBefore(list, count ? count.nextSibling : topbar.firstChild);
    topbar.setAttribute('data-byon-topbar-from', source.getAttribute('data-byon-topbar-from'));
    updateSubcatsOverflow();
  }

  /* ---------- Chips de subcategoría dentro de la barra (bajo 990 px) ---------- */
  function syncSubcategoryChips() {
    syncTopbarChips();
    var scroller = qs('#ProductGridContainer [data-byon-bar] .byon-bar__scroller');
    if (!scroller || qs('[data-byon-subcat]', scroller)) return;
    // Si la barra ya trae chips de tipo/categoría que filtran DENTRO de esta colección (p. ej. Ofertas o una marca),
    // no se mezclan con enlaces a otras colecciones: se evita sacar al usuario del contexto sin que lo note.
    // Los enlaces de subcategoría siguen en el HTML del encabezado (fila visible en desktop).
    var inContext = qsa('a.byon-chip[data-byon-qf]', scroller).some(function (chip) {
      return /product_type|\.tipo_|ingrediente/.test(chip.getAttribute('data-byon-qf') || '');
    });
    if (inContext) return;
    var source = qsa('.byon-colhead__chips a.byon-chip');
    if (!source.length) return;
    var fragment = doc.createDocumentFragment();
    source.forEach(function (link) {
      var clone = link.cloneNode(true);
      clone.classList.add('byon-chip--subcat');
      clone.setAttribute('data-byon-subcat', '');
      fragment.appendChild(clone);
    });
    var firstQuick = qs('a.byon-chip[data-byon-facet-link]:not(.is-active)', scroller);
    scroller.insertBefore(fragment, firstQuick || null);
  }

  /* ---------- Foco tras re-pintar la barra (teclado / lector de pantalla) ---------- */
  // La barra y el orden viven dentro de #ProductGridContainer, que facets.js reemplaza: se recuerda el control
  // con foco y se devuelve al equivalente nuevo (mismo id, mismo chip o el botón "Ordenar").
  var lastFocus = null;

  function normalizeLabel(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(el) {
    return !!(el && el.getClientRects().length);
  }

  function describeFocus(el) {
    if (el.closest('[data-byon-sort-sheet]') || el.matches('[data-byon-open-sort]')) return { sel: '[data-byon-open-sort]' };
    if (el.id) return { id: el.id };
    if (el.matches('.byon-chip, .byon-link-clear')) return { label: normalizeLabel(el.textContent) };
    return null;
  }

  // También al hacer clic (Enter en un chip): no depende de que el navegador emita focusin.
  function rememberFocus(el) {
    if (!el || !el.closest('#ProductGridContainer')) return;
    lastFocus = describeFocus(el);
    if (lastFocus) lastFocus.at = Date.now();
  }

  function restoreFocus() {
    var d = lastFocus;
    if (!d || Date.now() - d.at > 15000) return;
    var active = doc.activeElement;
    if ((active && active !== doc.body && doc.contains(active)) || facetsOpen()) return;
    lastFocus = null;
    var target = null;
    if (d.id) target = doc.getElementById(d.id);
    if (!isVisible(target) && d.sel) {
      target = qsa('#ProductGridContainer ' + d.sel).filter(isVisible)[0] || null;
    }
    if (!isVisible(target) && d.label) {
      target =
        qsa('#ProductGridContainer .byon-chip').filter(function (chip) {
          return isVisible(chip) && normalizeLabel(chip.textContent).indexOf(d.label) === 0;
        })[0] || null;
    }
    if (!isVisible(target)) {
      target = qsa('#ProductGridContainer [data-byon-open-filters], #ProductGridContainer select').filter(isVisible)[0] || null;
    }
    if (target) target.focus({ preventScroll: true });
  }

  /* ---------- Después de cada render de facets.js ---------- */
  function afterGridRender() {
    syncSubcategoryChips();
    syncHeaderCount();
    restoreFocus();
    if (facetsOpen()) {
      qsa('[data-byon-open-filters]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'true');
      });
    }
    collectStickyCandidates();
    requestStickyUpdate();
  }

  /* ---------- Cargar más ---------- */
  function productCount(grid) {
    return grid.querySelectorAll(':scope > li:not([data-byon-tile])').length;
  }

  function updateLoadMoreStatus(box, grid) {
    var total = parseInt(box.getAttribute('data-total'), 10) || 0;
    var start = parseInt(grid.getAttribute('data-byon-start') || '0', 10) || 0;
    var shown = start + productCount(grid);
    var status = qs('[data-byon-loadmore-status]', box);
    var noun = /resultados/.test(status ? status.textContent : '') ? 'resultados' : 'productos';
    if (status) {
      status.textContent =
        start > 0
          ? 'Mostrando ' + (start + 1) + '–' + shown + ' de ' + total + ' ' + noun
          : 'Mostrando ' + shown + ' de ' + total + ' ' + noun;
    }
    var bar = qs('[data-byon-loadmore-bar]', box);
    if (bar && total) bar.style.width = Math.min(100, Math.round((shown / total) * 100)) + '%';
    var label = qs('[data-byon-loadmore-label]', box);
    var remaining = total - shown;
    if (label && remaining > 0) {
      var next = Math.min(remaining, parseInt(box.getAttribute('data-page-size') || '24', 10) || 24);
      label.textContent = 'Cargar ' + next + ' más';
    }
  }

  function loadMore(link) {
    if (link.getAttribute('aria-busy') === 'true') return;
    var grid = doc.getElementById('product-grid');
    var box = link.closest('[data-byon-loadmore]');
    if (!grid || !box || !grid.getAttribute('data-id') || grid.tagName !== 'UL') {
      window.location.href = link.href;
      return;
    }
    if (!grid.hasAttribute('data-byon-start')) grid.setAttribute('data-byon-start', box.getAttribute('data-offset') || '0');
    var pageSize = productCount(grid);
    var target = new URL(link.href, window.location.href);
    var fetchUrl = new URL(target.toString());
    fetchUrl.searchParams.set('section_id', grid.getAttribute('data-id'));
    link.setAttribute('aria-busy', 'true');
    link.classList.add('is-loading');

    fetch(fetchUrl.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var items = qsa('#product-grid > li', parsed);
        if (!items.length) throw new Error('sin productos');
        var firstNew = null;
        items.forEach(function (item) {
          var node = doc.importNode(item, true);
          if (!firstNew) firstNew = node;
          grid.appendChild(node);
        });
        var nextBox = qs('[data-byon-loadmore]', parsed);
        var newBox = nextBox ? doc.importNode(nextBox, true) : null;
        if (newBox) {
          newBox.setAttribute('data-page-size', String(pageSize || 24));
          box.replaceWith(newBox);
          updateLoadMoreStatus(newBox, grid);
        } else {
          box.remove();
        }
        target.searchParams.delete('section_id');
        var params = target.searchParams.toString();
        try {
          window.history.replaceState({ searchParams: params }, '', target.pathname + (params ? '?' + params : ''));
        } catch (e) {}
        if (getFacets()) getFacets().searchParamsPrev = params;
        var focusLink = firstNew && qs('a.byon-card__link, a[href]', firstNew);
        if (focusLink) focusLink.focus({ preventScroll: true });
      })
      .catch(function () {
        window.location.href = link.href;
      });
  }

  /* ---------- Guía SEO colapsada ---------- */
  function setSeoOpen(body, open) {
    body.classList.toggle('is-open', open);
    var button = qs('[data-byon-seo-toggle][aria-controls="' + body.id + '"]');
    if (!button) return;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    var more = qs('[data-byon-more]', button);
    var less = qs('[data-byon-less]', button);
    if (more) more.hidden = open;
    if (less) less.hidden = !open;
  }

  function initSeo() {
    qsa('[data-byon-seo-body]').forEach(function (body) {
      if (body.hasAttribute('data-byon-init')) return;
      body.setAttribute('data-byon-init', '');
      var button = qs('[data-byon-seo-toggle][aria-controls="' + body.id + '"]');
      if (body.scrollHeight <= body.clientHeight + 8) {
        body.classList.add('is-open');
        if (button) button.hidden = true;
      } else if (button) {
        button.hidden = false;
      }
    });
    if (window.location.hash === '#byon-guia') expandSeo();
  }

  function expandSeo() {
    qsa('[data-byon-seo-body]').forEach(function (body) {
      setSeoOpen(body, true);
    });
  }

  /* ---------- Medición de chips y "Borrar todo" (K1) ---------- */
  function trackFacetLink(link) {
    if (link.hasAttribute('data-byon-clear')) {
      track('filter_apply', { filter: 'all', value: 'all', action: 'clear', collection: collectionKey() });
    } else if (link.hasAttribute('data-byon-qf')) {
      track('filter_apply', {
        filter: link.getAttribute('data-byon-qf'),
        value: link.getAttribute('data-byon-qv') || '',
        action: link.getAttribute('data-byon-qa') === 'remove' ? 'remove' : 'add',
        collection: collectionKey(),
      });
    }
  }

  function searchTerm(link) {
    try {
      var q = new URL(link.href, window.location.href).searchParams.get('q');
      if (q) return q;
    } catch (e) {}
    return normalizeLabel(link.textContent);
  }

  /* ---------- Eventos ---------- */
  doc.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var trigger = target.closest('[data-byon-open-filters]');
    if (trigger) {
      event.preventDefault();
      if (window.ByonFacets) window.ByonFacets.open(trigger);
      return;
    }

    trigger = target.closest('[data-byon-open-sort]');
    if (trigger) {
      event.preventDefault();
      openSortSheet(trigger);
      return;
    }

    // Solo las opciones de la hoja: el mega-menú del header también usa data-byon-sort (en contenedores de productos).
    trigger = target.closest('[data-byon-sort-sheet] [data-byon-sort]');
    if (trigger) {
      event.preventDefault();
      rememberFocus(trigger);
      applySort(trigger.getAttribute('data-byon-sort'));
      return;
    }

    trigger = target.closest('[data-byon-sheet-close]');
    if (trigger) {
      event.preventDefault();
      closeSortSheet(false);
      return;
    }

    trigger = target.closest('a[data-byon-facet-link]');
    if (trigger && isPlainClick(event)) {
      trackFacetLink(trigger);
      if (canAjax()) {
        event.preventDefault();
        rememberFocus(trigger);
        renderFromHref(trigger.href);
      }
      return;
    }

    trigger = target.closest('a[data-byon-loadmore-link]');
    if (trigger && isPlainClick(event)) {
      event.preventDefault();
      loadMore(trigger);
      return;
    }

    trigger = target.closest('a[data-byon-search-chip]');
    if (trigger) {
      track('search_submit', { term: searchTerm(trigger), search_source: 'search_empty_chip' });
      return;
    }

    trigger = target.closest('[data-byon-seo-toggle]');
    if (trigger) {
      event.preventDefault();
      var body = doc.getElementById(trigger.getAttribute('aria-controls'));
      if (body) setSeoOpen(body, !body.classList.contains('is-open'));
      return;
    }

    trigger = target.closest('a[href="#byon-guia"]');
    if (trigger) expandSeo();
  });

  // Selector de orden de la barra superior (facets.js lo aplica con su 'input'); aquí solo se mide.
  doc.addEventListener('change', function (event) {
    var select = event.target;
    if (!(select instanceof HTMLSelectElement) || select.name !== 'sort_by' || !select.closest('#FacetSortForm')) return;
    rememberFocus(select);
    if (select.value !== currentSort()) track('sort_change', { sort_by: select.value, collection: collectionKey() });
  });

  doc.addEventListener('submit', function (event) {
    var form = event.target;
    if (event.defaultPrevented || !(form instanceof HTMLFormElement) || !form.hasAttribute('data-byon-search-form')) return;
    var input = form.querySelector('input[name="q"]');
    var term = input ? input.value.trim() : '';
    if (term) track('search_submit', { term: term, search_source: 'search_page' });
  });

  doc.addEventListener('focusin', function (event) {
    var el = event.target;
    if (!(el instanceof Element)) return;
    lastFocus = el.closest('#ProductGridContainer') ? describeFocus(el) : null;
    if (lastFocus) lastFocus.at = Date.now();
  });

  doc.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.code !== 'Escape') return;
    if (qsa('[data-byon-sort-sheet]').some(function (s) { return !s.hidden; })) {
      event.preventDefault();
      closeSortSheet(false);
    }
  });

  window.addEventListener('scroll', requestStickyUpdate, { passive: true });
  window.addEventListener('resize', function () {
    collectStickyCandidates();
    requestStickyUpdate();
    updateSubcatsOverflow();
  });

  function init() {
    collectStickyCandidates();
    updateStickyTop();
    syncSubcategoryChips();
    syncHeaderCount();
    initSeo();
    // Con la fuente definitiva (Poppins) los chips pueden medir distinto: se vuelve a comprobar que caben
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(updateSubcatsOverflow);

    var container = doc.getElementById('ProductGridContainer');
    if (container) {
      var renderTimer = null;
      new MutationObserver(function () {
        window.clearTimeout(renderTimer);
        renderTimer = window.setTimeout(afterGridRender, 0);
      }).observe(container, { childList: true });
    }
  }

  ByonPLP.applySort = applySort;
  ByonPLP.renderFromHref = renderFromHref;
  ByonPLP.openFilters = function (trigger) {
    if (window.ByonFacets) window.ByonFacets.open(trigger);
  };
  ByonPLP.refresh = afterGridRender;
  ByonPLP.scrollToResults = scrollToResults;

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
})();